export default __webpack_public_path__ + "static/differentiate-headings-do-a8ef240798f4763ae1f02a9b881fc0bb.png";